import EventTileActions from './event-tile-actions'
export default EventTileActions
